const mEditionBillingModifyPassword = {
  mEditionBillingModifyPassword: {
    alerts: {
      messageSuccess: 'La contraseña fue actualizada correctamente. La nueva contraseña es ',
      messageError: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.'
    }
  }
}

export default mEditionBillingModifyPassword
